export var IterableIterators;
(function (IterableIterators) {
    function* empty() { return; }
    IterableIterators.empty = empty;
    function* flatten(...generators) {
        for (const generator of generators) {
            for (const value of generator) {
                yield value;
            }
        }
    }
    IterableIterators.flatten = flatten;
})(IterableIterators || (IterableIterators = {}));
